module.exports = __webpack_public_path__ + "media/images/homes/DineIn-32bbda9b09f82a7857159a89a7662d5b.png";